import { getSettlementLetter } from 'feature/settlementLetters/settlementLettersSlice';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AppDispatch, RootState } from 'store/store';
import { Box, BoxOverflow, Stack } from 'styles';
import { ISettlementLettersDocument } from 'types/SettlementLetters';
import DocumentRenderer from './components/DocumentRenderer.component';
import DocumentsList from './components/DocumentsList.component';
import SettlementLettersFilters from './components/SettlementLettersFilters.component';

const ViewSettlementLettersPage = () => {
	const dispatch = useDispatch<AppDispatch>();
	const { uuid } = useParams();

	const { documents, expandView, loaded } = useSelector(
		(store: RootState) => store.settlementLetters,
	);

	const [selectedDocument, setSelectedDocument] = useState<
		ISettlementLettersDocument | undefined
	>();

	const handleClickSelectDocument = (uuid: string) => {
		const selectedDoc = documents.find(doc => doc.uuid === uuid);
		setSelectedDocument(selectedDoc);
	};

	useEffect(() => {
		if (!uuid) {
			setSelectedDocument(documents[0]);
		}

		const selectedDoc = documents.find(doc => doc.uuid === String(uuid));

		if (!selectedDoc) {
			setSelectedDocument(documents[0]);
		} else {
			setSelectedDocument(selectedDoc);
		}
	}, [documents, uuid]);

	useEffect(() => {
		if (selectedDocument) {
			dispatch(getSettlementLetter({ uuid: selectedDocument.uuid }));
		}
	}, [dispatch, selectedDocument]);

	return (
		<Stack gap={'25px'}>
			<Stack>
				<SettlementLettersFilters />
			</Stack>
			{loaded && (
				<Box
					display={'grid'}
					gridTemplateColumns={!expandView ? '1fr' : '420px 1fr'}
					gap={'28px'}
				>
					{expandView && (
						<Stack height={'calc(100dvh - 330px)'}>
							<BoxOverflow
								variant="y"
								sx={{
									cursor: 'pointer',
									paddingRight: '10px',
								}}
							>
								<DocumentsList
									documents={documents}
									selectedDocId={selectedDocument?.uuid}
									onSelectDocument={handleClickSelectDocument}
								/>
							</BoxOverflow>
						</Stack>
					)}
					<Stack>
						<DocumentRenderer selectedDocument={selectedDocument} />
					</Stack>
				</Box>
			)}
		</Stack>
	);
};

export default ViewSettlementLettersPage;
